// import React, { useState, useEffect } from "react";
export default function FlightLanding() {
  return (
    <img
      className="svg_lifeline"
      src="/svg/flight-landing.svg"
      alt=""
    />
  );
}
